var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',_vm._g(_vm._b({staticClass:"er-form-item"},'el-form-item',_vm.$attrs,false),_vm.inputListeners),[_vm._t("default"),_vm._t("label")],2)}
var staticRenderFns = []

export { render, staticRenderFns }